import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'merenja';

export async function dodajMerenje(userId, podaci) {
  return addDoc(collection(db, COLLECTION), {
    userId,
    ...podaci,
    createdAt: serverTimestamp()
  });
}

export async function getMerenja(userId) {
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    orderBy('datumVreme', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function obrisiMerenje(id) {
  return deleteDoc(doc(db, COLLECTION, id));
}
